import { StrictMode } from "react";

import { ConfigProvider } from "antd";
import jaJP from "antd/lib/locale/ja_JP";
import ReactDOM from "react-dom/client";
import { ToastContainer } from "react-toastify";

import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import "./index.css";
import ReactQueryProvider from "./providers/ReactQueryProvider";
import reportWebVitals from "./reportWebVitals";
// Configure dayjs with Japan timezone (UTC+9)
import "./utils/datetime/dayjs";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <StrictMode>
    <ConfigProvider locale={jaJP}>
      <ToastContainer />
      <ReactQueryProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ReactQueryProvider>
    </ConfigProvider>
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
